import type { EventName } from "@lit/react";
import { TimePicker as TimePickerElement, type TimePickerEventMap as _TimePickerEventMap, } from "@vaadin/time-picker/vaadin-time-picker.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { TimePickerElement, };
export type TimePickerEventMap = Readonly<{
    onChange: EventName<_TimePickerEventMap["change"]>;
    onInput: EventName<_TimePickerEventMap["input"]>;
    onInvalidChanged: EventName<_TimePickerEventMap["invalid-changed"]>;
    onOpenedChanged: EventName<_TimePickerEventMap["opened-changed"]>;
    onValidated: EventName<_TimePickerEventMap["validated"]>;
    onValueChanged: EventName<_TimePickerEventMap["value-changed"]>;
}>;
const events = { onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onOpenedChanged: "opened-changed", onValidated: "validated", onValueChanged: "value-changed" } as TimePickerEventMap;
export type TimePickerProps = WebComponentProps<TimePickerElement, TimePickerEventMap>;
export const TimePicker = createComponent({
    elementClass: TimePickerElement, events, react: React, tagName: "vaadin-time-picker"
});
